/**
 * Ryan O'Dowd
 * 2022-05-22
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const WalkthroughTooltipContent = (props: WalkthroughTooltipContentProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      <View style={styles.topWrapper}>
        <View style={styles.header}>
          <Text style={styles.title}>
            {props.title}
          </Text>
        </View>
        {props.content}
      </View>
    </View>
  );
};

class WalkthroughTooltipContentProps {
  content: any;
  title: string;
};

export default WalkthroughTooltipContent;
